export enum OnboardingSlackStep {
  Install = 'Install',
  Reactji = 'Reactji',
  CreateFeedback = 'CreateFeedback',
  FeedbackCreated = 'FeedbackCreated',
  ExtractInsight = 'ExtractInsight',
}
